import { IPageableRequest } from '../request.model';

export interface IParkingEventsModel {
  parkingId: string;
  eventType: ParkingEvents;
  freeSpotsCount: 0;
  stateLicencePlate: string;
  eventTimestamp: string;
  userId: string;
  operatorId: string;
}

export enum ParkingEvents {
  Entry,
  Exit,
}

export interface IParkingEventsFilter extends IPageableRequest {
  operatorId: string;
}
